import { withLocalize } from "react-localize-redux";
import { useHistory } from "react-router-dom";
import translations from "../../translations/verify.json";
import signupTranslations from "../../translations/signup.json";
import claimFlowTranslations from "../../translations/claimFlow.json";
import "../../styles/credential/credentialMobile.scss";
import {
	CredentialEarningCriteriaBlock,
	CredentialRatingEnrollmentBlock,
	CredentialSupportingDocumentationsBlock,
	CampaignMediaActionRow,
	CampaignMainInfoCard,
	CampaignDetailBlock,
	CampaignDescriptionBlock,
	CredentialSkillsBlock,
} from "wallet-elementkit/dist/components";
import mixpanel from "mixpanel-browser";
import { OptimizedMixPanel } from "wallet-elementkit/dist/services";
import { selectUser } from "../../store/features/user";
import { useAppDispatch, useAppSelector } from "../../store/hooks";

const CredentialMobile = (props) => {
	props.addTranslation(signupTranslations);
	props.addTranslation(claimFlowTranslations);
	props.addTranslation(translations);
	const userMeta = useAppSelector(selectUser);
	const dispatch = useAppDispatch();

	const optimizedMixpanel = new OptimizedMixPanel(mixpanel);

	const history = useHistory();

	return (
		<div id="credential-mobile" className={`flex-column jc-fs ai-c`}>
			<CampaignMainInfoCard
				{...props}
				isMobile={true}
				navigateToIssuerProfile={() => {
					optimizedMixpanel?.track("Visit Issuer Profile", {
						credential_no: props.credNo,
						isLogged: userMeta.logged,
						issuer_id: props.campaign?.organization.id,
					});
					window.open(
						window.location.origin +
							`/${
								props.activeLanguage
									? props.activeLanguage.code
									: process.env.REACT_APP_DEFAULT_LANGUAGE ?? "en"
							}/issuer-profile/${props.campaign?.organization.id}/`,
						"_blank"
					);
				}}
				navigateToPathway={(pathwayId) => {
					history.push(
						`/${
							props.activeLanguage
								? props.activeLanguage.code
								: process.env.REACT_APP_DEFAULT_LANGUAGE ?? "en"
						}/pathway/${pathwayId}/`
					);
				}}
			/>

			<CampaignMediaActionRow
				{...props}
				dispatch={dispatch}
				historyPush={history.push}
				isMobile={true}
				mixPanel={mixpanel}
				campaign={props.campaign}
			/>
			<div className="verify-inner-details">
				<CampaignDetailBlock
					{...props}
					cost={props.campaign?.detail.cost.toString()}
					duration={props.campaign?.detail.duration.toString()}
					level={props.campaign?.detail.level.toString()}
					type={props.campaign?.detail.type.toString()}
				/>
				{!props.loading &&
					props.attendeeCount > 0 &&
					props.courseRatingCount > 0 && (
						<CredentialRatingEnrollmentBlock
							{...props}
							type={props.type}
							courseRating={props.courseRating}
							courseRatingCount={props.courseRatingCount}
							attendeeCount={props.attendeeCount}
						/>
					)}
				{!props.loading && (
					<CampaignDescriptionBlock
						description={props.campaign?.detail.description}
						{...props}
					/>
				)}
				{!props.loading &&
					props.campaign?.detail.skills &&
					props.campaign?.detail.skills.length > 0 && (
						<CredentialSkillsBlock
							navigateToSkillPage={(skillId) => {
								history.push(
									`/${
										props.activeLanguage
											? props.activeLanguage.code
											: process.env.REACT_APP_DEFAULT_LANGUAGE ?? "en"
									}/skill/${skillId}/`
								);
							}}
							{...props}
							skills={props.campaign?.detail.skills.map((skill) => ({
								...skill,
								id: 1212,
							}))}
						/>
					)}
				{((!props.loading && props.evidences && props.evidences.length > 0) ||
					props.earningCriteriaHTML) && (
					<CredentialEarningCriteriaBlock
						earningCriteriaHtml={props.earningCriteriaHTML}
						{...props}
					/>
				)}
				{!props.loading &&
					props.supportingDocumentationsWithMeta.length > 0 && (
						<CredentialSupportingDocumentationsBlock {...props} />
					)}
			</div>
		</div>
	);
};

export default withLocalize(CredentialMobile);
